/**
 * @file コンポーネント：プライバシーポリシー確認モーダル ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnHandleApiErrors } from "~/src/functions/common";

// コンポーネントを返す
export const ModalPrivacypolicy = (props) => {
    /**
     * 同意取得フラグ
     */
    const [isAgreed, setIsAgreed] = useState(false);

    /**
     * モーダル開閉状態
     */
    const [isShow, setIsShow] = useState(false);
    // ログイン時かつ同意未取得の場合にモーダルを開く
    useEffect(() => {
        if (
            window.dataUser.isLogin &&
            !window.dataUser.isPrivacyPolicyConsent
        ) {
            setIsShow(true);
        }
    }, [window.dataUser.isLogin, window.dataUser.isPrivacyPolicyConsent]);
    // 同意取得時にモーダルを閉じる
    const fnSendPrivacypolicyAgreed = (e) => {
        e.preventDefault();
        const api = "/api/users/updatePrivacyPolicyConsent";
        const options = {
            body: null,
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "POST",
        };
        fetch(api, options)
            .then(fnHandleApiErrors)
            .then((response) => {
                if (response.status === 200) {
                    setIsShow(false);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnSendPrivacypolicyAgreed={fnSendPrivacypolicyAgreed}
            isAgreed={isAgreed}
            isShow={isShow}
            setIsAgreed={setIsAgreed}
        />
    );
};
